module.exports = __webpack_public_path__ + "img/weixin.6ec1fc1e.png";